export default __webpack_public_path__ + "static/media/bus.e1fc0ff4.jpg";